// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"9c79f2bc","286":"dbc78a18","488":"25f50f7a"}[chunkId] + ".chunk.js";
};